module.exports = __webpack_public_path__ + "img/vue1-renfort_noir.b57b6476.png";